(function () {
  window.isolaEmbroideryVersion = "2026-08-17.1";

  var fontStyles = {
    "Fonte 1": {
      family: "\"Bebas Neue\", Arial, sans-serif",
      weight: "400",
      spacing: "0.12em",
      transform: "uppercase"
    },
    "Fonte 2": {
      family: "\"Great Vibes\", \"MonteCarlo\", \"Brush Script MT\", cursive",
      weight: "400",
      spacing: "0",
      transform: "none"
    },
    "Fonte 3": {
      family: "\"Imperial Script\", \"Great Vibes\", \"Brush Script MT\", cursive",
      weight: "400",
      spacing: "0",
      transform: "none"
    },
    "Fonte 4": {
      family: "\"MonteCarlo\", \"Great Vibes\", \"Brush Script MT\", cursive",
      weight: "400",
      spacing: "0",
      transform: "none"
    },
    "Fonte 5": {
      family: "\"Lobster Two\", \"Great Vibes\", cursive",
      weight: "700",
      spacing: "0",
      transform: "none"
    },
    "Fonte 6": {
      family: "\"Cormorant Unicase\", \"Cormorant Garamond\", Georgia, serif",
      weight: "600",
      spacing: "0.045em",
      transform: "uppercase"
    }
  };

  function setFieldState(fields, enabled) {
    fields.forEach(function (field) {
      if (field.hasAttribute("data-embroidery-enabled")) return;
      field.disabled = !enabled;
    });
  }

  function setupEmbroidery(block) {
    if (block.dataset.isolaEmbroideryReady === "true") return;

    var form = block.closest("form");
    var enabledInput = block.querySelector("[data-embroidery-enabled]");
    var fieldsWrap = block.querySelector("[data-embroidery-fields]");
    var layoutInput = block.querySelector("[data-embroidery-layout]");
    var textInput = block.querySelector("[data-embroidery-text]");
    var line2Field = block.querySelector("[data-embroidery-line2-field]");
    var line2Input = block.querySelector("[data-embroidery-line2]");
    var helpText = block.querySelector("[data-embroidery-help]");
    var typeInput = block.querySelector("[data-embroidery-type]");
    var fontInput = block.querySelector("[data-embroidery-font]");
    var sizeInput = block.querySelector("[data-embroidery-size]");
    var positionInput = block.querySelector("[data-embroidery-position]");
    var previewText = block.querySelector("[data-embroidery-preview-text]");
    var previewValueInput = block.querySelector("[data-embroidery-preview-value]");
    var sampleWrap = block.querySelector("[data-embroidery-sample]");
    var sampleToggle = block.querySelector("[data-embroidery-sample-toggle]");
    var samplePanel = block.querySelector("[data-embroidery-sample-panel]");
    var sampleImage = block.querySelector("[data-embroidery-sample-image]");
    var sampleClose = block.querySelector("[data-embroidery-sample-close]");
    var sampleTitle = block.querySelector("[data-embroidery-sample-title]");
    var propertyFields = Array.prototype.slice.call(block.querySelectorAll("input, select, textarea"));

    if (!enabledInput || !fieldsWrap || !layoutInput || !textInput || !typeInput || !fontInput || !sizeInput || !positionInput || !previewText) return;

    block.dataset.isolaEmbroideryReady = "true";

    function getSelectedColor() {
      return block.querySelector("[data-embroidery-color]:checked");
    }

    function getPlaceholderByType(type) {
      if (type === "Nome") return "Ex: Luiza";
      if (type === "Frase curta") return "Ex: Bons sonhos";
      if (type === "Uma letra") return "Ex: A";
      if (type === "Duas letras") return "Ex: AB";
      return "Ex: ABC";
    }

    function getMaxLengthBySize() {
      if (!sizeInput) return 10;
      if (sizeInput.value.indexOf("7,0 cm") === 0) return 6;
      if (sizeInput.value.indexOf("5,0 cm") === 0) return 8;
      return 10;
    }

    function getMaxLengthByType(type) {
      if (type === "Nome") return 16;
      if (type === "Frase curta") return 24;
      if (type === "Uma letra") return 1;
      if (type === "Duas letras") return 2;
      return 3;
    }

    function isLetterType(type) {
      return type === "Tres letras" || type === "Duas letras" || type === "Uma letra";
    }

    function getPreviewFallback(type) {
      if (type === "Nome") return "Luiza";
      if (type === "Frase curta") return "Teste de escrita";
      if (type === "Uma letra") return "A";
      if (type === "Duas letras") return "AB";
      return "ABC";
    }

    function applyFontStyle(fontName) {
      var style = fontStyles[fontName];
      if (!style) return;

      previewText.style.setProperty("--embroidery-font-family", style.family);
      previewText.style.setProperty("--embroidery-font-weight", style.weight);
      previewText.style.setProperty("--embroidery-letter-spacing", style.spacing);
      previewText.style.setProperty("--embroidery-text-transform", style.transform);
    }

    function updateSampleImage() {
      if (!sampleWrap || !sampleToggle || !samplePanel || !sampleImage) return;

      var selectedOption = fontInput.options[fontInput.selectedIndex];
      var defaultSampleUrl = sampleWrap.getAttribute("data-default-sample-image") || "";
      var sampleUrl = selectedOption ? selectedOption.getAttribute("data-sample-image") : "";
      sampleUrl = sampleUrl || defaultSampleUrl;

      if (!sampleUrl) {
        sampleWrap.hidden = true;
        samplePanel.hidden = true;
        sampleToggle.setAttribute("aria-expanded", "false");
        sampleImage.removeAttribute("src");
        sampleImage.alt = "";
        return;
      }

      sampleWrap.hidden = false;
      sampleImage.src = sampleUrl;
      sampleImage.alt = "Exemplo real da fonte " + fontInput.value + " em bordado";
      if (sampleTitle) {
        sampleTitle.textContent = "Exemplo real - " + fontInput.value;
      }
    }

    function openSamplePanel() {
      if (!sampleToggle || !samplePanel) return;
      document.body.appendChild(samplePanel);
      samplePanel.hidden = false;
      document.documentElement.classList.add("isola-embroidery-modal-open");
      sampleToggle.setAttribute("aria-expanded", "true");
    }

    function closeSamplePanel() {
      if (!sampleToggle || !samplePanel) return;
      samplePanel.hidden = true;
      if (sampleWrap) sampleWrap.appendChild(samplePanel);
      document.documentElement.classList.remove("isola-embroidery-modal-open");
      sampleToggle.setAttribute("aria-expanded", "false");
    }

    function updatePreview() {
      var selectedColor = getSelectedColor();
      var layout = layoutInput.value;
      var type = typeInput.value;
      var maxLength = Math.min(getMaxLengthByType(type), getMaxLengthBySize());
      var text = textInput.value.trim();
      var line2 = line2Input ? line2Input.value.trim() : "";

      textInput.maxLength = maxLength;
      textInput.placeholder = getPlaceholderByType(type);

      if (line2Field) {
        line2Field.hidden = layout !== "Duas linhas";
      }

      if (line2Input) {
        line2Input.disabled = !enabledInput.checked || layout !== "Duas linhas";
      }

      if (helpText) {
        helpText.textContent = isLetterType(type)
          ? "Para monograma, informe as letras na ordem desejada."
          : "O texto sera bordado exatamente como informado. O tamanho escolhido permite ate " + getMaxLengthBySize() + " letras.";
      }

      if (text.length > maxLength) {
        text = text.slice(0, maxLength);
        textInput.value = text;
      }

      if (isLetterType(type)) {
        text = text.replace(/[^A-Za-zÀ-ÿ]/g, "").slice(0, maxLength).toUpperCase();
        textInput.value = text;
      }

      var fallbackText = getPreviewFallback(type);

      previewText.textContent = layout === "Duas linhas"
        ? [text || fallbackText, line2 || "Linha 2"].join("\n")
        : text || fallbackText;
      previewText.setAttribute("data-stitch-text", previewText.textContent);
      previewText.style.color = selectedColor ? selectedColor.getAttribute("data-embroidery-color") : "#315f79";
      previewText.dataset.layout = layout;
      previewText.dataset.type = type;
      previewText.dataset.font = fontInput.value;
      previewText.dataset.size = sizeInput.value;
      previewText.dataset.position = positionInput.value;
      applyFontStyle(fontInput.value);
      updateSampleImage();

      if (previewValueInput) {
        previewValueInput.value = enabledInput.checked
          ? [layout, text || fallbackText, line2 || "", type, fontInput.value, sizeInput.value, selectedColor ? selectedColor.value : "", positionInput.value].join(" | ")
          : "";
      }
    }

    function updateEnabledState() {
      var enabled = enabledInput.checked;
      fieldsWrap.hidden = !enabled;
      setFieldState(propertyFields, enabled);
      enabledInput.disabled = false;
      updatePreview();
    }

    enabledInput.addEventListener("change", updateEnabledState);
    block.addEventListener("input", updatePreview);
    block.addEventListener("change", updatePreview);
    if (sampleToggle && samplePanel) {
      sampleToggle.addEventListener("click", function () {
        if (samplePanel.hidden) {
          openSamplePanel();
        } else {
          closeSamplePanel();
        }
      });
    }
    if (sampleClose) {
      sampleClose.addEventListener("click", closeSamplePanel);
    }
    if (samplePanel) {
      samplePanel.addEventListener("click", function (event) {
        if (event.target === samplePanel) closeSamplePanel();
      });
    }
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && samplePanel && !samplePanel.hidden) {
        closeSamplePanel();
      }
    });

    updateEnabledState();
  }

  function initEmbroidery(context) {
    var root = context || document;

    root.querySelectorAll("[data-isola-embroidery]").forEach(setupEmbroidery);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initEmbroidery(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initEmbroidery(event.target);
  });

  if (document.readyState !== "loading") {
    document.querySelectorAll("[data-isola-embroidery]").forEach(setupEmbroidery);
  }
})();
